module.exports = __webpack_public_path__ + "img/skin-1@3x.17835ff1.png";